import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import {Link} from "react-router-dom";
import * as routes from "../constants/routes";
import LogoutButton from "./LogoutButton"

class NavBar extends React.Component {
    render() {
        return (
            <div>
                <AppBar position="static" style={{ background: '#2E3B55' }}>
                    <Toolbar>
                        <Link to={routes.landing}>
                            <Button style={{color: '#fff'}}>Yomi</Button>
                        </Link>
                        <Link to={routes.privacy}>
                            <Button style={{color: '#fff'}}>Privacy</Button>
                        </Link>
                        <div style={{flexGrow: 1}}/>
                        <LogoutButton/>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

export default NavBar;
